import React, { ReactElement } from 'react';

import { classNames } from 'utils/css';

import { TIconProps } from './Icon.types';
import styles from './Icon.module.scss';

function Icon({ name, color, align, size }: TIconProps): ReactElement {
  const className = classNames(
    styles.iconWrapper,
    color && styles[color],
    align && styles[align]
  );

  return (
    <div className={className} data-testid="Icon">
      <span className={`icon-${name}`} style={{ fontSize: `${size}px` }} />
    </div>
  );
}

export { Icon };
